import React, { useState, useEffect, useRef } from 'react';

import styles from './index.less';

import {
  Descriptions,
  Modal,
  Table,
  Button,
  Input,
  message,
  Image,
  Tag,
  Form,
  Space,
  Radio,
  Popconfirm,
  Divider,
  Popover,
} from 'antd';
import {
  modifyTenantThirdInfo,
  getEnterprise,
  enterpriseVerification,
  modifyEnterpriseInfo,
} from '@/services/athena';
import ImgUpload from '@/components/ImgUpload';
import {
  getBindTenantList,
  unBindChannel,
  bindTenant,
  getBindBrandList,
  getChannelListForBind,
} from '@/services/channel';

import ProTable from '@ant-design/pro-table';
import DebounceSelect from '@/components/DebounceSelect';

import {
  EnvironmentTwoTone,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';

const MerchantInfo = (props) => {
  // eslint-disable-next-line react/prop-types
  const {
    tenantInfo = {},
    onRefresh,
    bindAction,
    onBindActionHandled,
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingField, setEditingField] = useState(null); // { recordKey, field }
  const [originalData, setOriginalData] = useState({});
  // 本地状态存储修改后的小红书ID和视频号ID
  const [localXhsId, setLocalXhsId] = useState(tenantInfo.redBookAccountId);
  const [localVideoId, setLocalVideoId] = useState(
    tenantInfo.wechatVideoAccountId,
  );
  // 从tenantInfo获取真实数据
  const [dataSource, setDataSource] = useState([]);

  const [stateForm] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [bindModalVisible, setBindModalVisible] = useState(false);
  const [bindOptionModalVisible, setBindOptionModalVisible] = useState(false);
  const actionRef = useRef(null);
  const [releaseForm] = Form.useForm();

  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    if (!bindAction) return;
    if (bindAction.type === 'bindList') {
      setBindModalVisible(true);
      onBindActionHandled && onBindActionHandled();
      return;
    }
    fetchUserList('', 1)
      .then((res) => {
        setDefaultOptions(Array.isArray(res) ? res : []);
        setBindOptionModalVisible(true);
        onBindActionHandled && onBindActionHandled();
      })
      .catch(() => {
        setDefaultOptions([]);
        message.error('获取归属选项失败，请稍后重试');
        onBindActionHandled && onBindActionHandled();
      });
  }, [bindAction]);

  // 居中
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };
  const layout = {
    // 标签长度
    labelCol: {
      span: 6,
    },
    // 表单长度
    wrapperCol: {
      span: 16,
    },
  };
  // 初始化数据源
  useEffect(() => {
    if (
      tenantInfo.tenantThirdAccountModels &&
      tenantInfo.tenantThirdAccountModels.length > 0
    ) {
      const formattedData = tenantInfo.tenantThirdAccountModels.map(
        (item, index) => {
          return {
            key: String(index + 1),
            ...item, // 直接使用真实数据字段
          };
        },
      );
      setDataSource(formattedData);
    } else {
      // 如果没有数据，设置空数组
      setDataSource([]);
    }
  }, [tenantInfo.tenantThirdAccountModels]);

  const handleEdit = (record, field) => {
    // 如果当前有正在编辑的字段，先取消编辑并恢复原始值
    if (editingField && originalData) {
      const newData = dataSource.map((item) => {
        if (item.key === editingField.recordKey) {
          return {
            ...item,
            [editingField.field]: originalData[editingField.field],
          };
        }
        return item;
      });
      setDataSource(newData);
    }

    // 保存新的原始数据并设置编辑状态
    setOriginalData({ ...record });
    setEditingField({ recordKey: record.key, field });
  };

  const handleSave = async () => {
    // 保存逻辑
    if (editingField) {
      const currentRecord = dataSource.find(
        (item) => item.key === editingField.recordKey,
      );
      if (currentRecord) {
        try {
          // 构建API请求参数
          const params = {
            requestData: {
              category: currentRecord.category || 0,
              storeType: currentRecord.storeType || 0,
              thirdBuyerId: currentRecord.thirdBuyerId || '',
              thirdAccountId: currentRecord.thirdAccountId || '',
              thirdAccountImg: currentRecord.thirdAccountImg || '',
              tenantId: tenantInfo.tenantId || 0,
            },
          };

          // 调用修改接口
          const response = await modifyTenantThirdInfo(params);

          if (response && response.data) {
            message.success('保存成功');

            // 根据storeType更新本地状态
            if (
              currentRecord.storeType === 5 &&
              editingField.field === 'thirdAccountId'
            ) {
              setLocalXhsId(currentRecord.thirdAccountId);
            } else if (
              currentRecord.storeType === 3 &&
              editingField.field === 'thirdAccountId'
            ) {
              setLocalVideoId(currentRecord.thirdAccountId);
            }
            setEditingField(null);
            setOriginalData({});

            // 调用外层刷新函数
            if (onRefresh && typeof onRefresh === 'function') {
              onRefresh();
            }
          } else {
            message.error(response?.msg || '保存失败');
          }
        } catch (error) {
          console.error('保存失败:', error);
          message.error('保存失败，请重试');
        }
      }
    }
  };

  const handleCancel = () => {
    // 恢复原始数据
    if (editingField && originalData) {
      const newData = dataSource.map((item) => {
        if (item.key === editingField.recordKey) {
          return {
            ...item,
            [editingField.field]: originalData[editingField.field],
          };
        }
        return item;
      });
      setDataSource(newData);
    }
    setEditingField(null);
    setOriginalData({});
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    // 关闭弹窗时，如果有正在编辑的字段，取消编辑并恢复原始值
    if (editingField && originalData) {
      const newData = dataSource.map((item) => {
        if (item.key === editingField.recordKey) {
          return {
            ...item,
            [editingField.field]: originalData[editingField.field],
          };
        }
        return item;
      });
      setDataSource(newData);
    }
    setIsModalVisible(false);
    setEditingField(null);
    setOriginalData({});
  };

  const handleModalCancel = () => {
    // 关闭弹窗时，如果有正在编辑的字段，取消编辑并恢复原始值
    if (editingField && originalData) {
      const newData = dataSource.map((item) => {
        if (item.key === editingField.recordKey) {
          return {
            ...item,
            [editingField.field]: originalData[editingField.field],
          };
        }
        return item;
      });
      setDataSource(newData);
    }
    setIsModalVisible(false);
    setEditingField(null);
    setOriginalData({});
  };

  function stateFormSubmit() {
    stateForm.validateFields().then((values) => {
      enterpriseVerification({
        requestData: { ...values, tenantId: tenantInfo.tenantId },
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('处理成功');
        } else {
          message.error(msg || '处理失败');
        }
        // 清空表单
        stateForm.resetFields();
        setVisible(false);
        onRefresh();
        getQwDetail();
      });
    });
  }
  function stateFormCancel() {
    stateForm.resetFields();
    setVisible(false);
  }
  // 商家状态
  function renderStateModal() {
    return (
      <div>
        <Modal
          title="审核"
          visible={visible}
          onCancel={stateFormCancel}
          width={800}
          footer={null}
        >
          <Form
            className={styles.formGap}
            form={stateForm}
            name="edit"
            {...layout}
          >
            <Form.Item
              label="审核状态"
              name="enterpriseVerificationStatus"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value={2}>待审核</Radio>
                <Radio value={3}>审核通过</Radio>
                <Radio value={4}>审核不通过</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="enterpriseVerificationRemark"
              label="备注说明"
              rules={[
                {
                  message: '请输入备注说明',
                },
              ]}
            >
              <Input.TextArea
                allowClear
                bordered
                maxLength={256}
                showCount
                autoSize={{ minRows: 3, maxRows: 6 }}
                placeholder={'请输入备注说明'}
              />
            </Form.Item>

            <Form.Item {...tailLayout}>
              <Space size={100}>
                <Button type="primary" onClick={stateFormSubmit}>
                  确定
                </Button>
                <Button type="primary" onClick={stateFormCancel}>
                  取消
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  // 企业信息
  const [qwModalVisible, setQwModalVisible] = useState(false);
  const [qwDetail, setQwDetail] = useState({});
  const [editQwModalVisible, setEditQwModalVisible] = useState(false);
  const [editQwForm] = Form.useForm();
  const [licenseImageList, setLicenseImageList] = useState([]);
  const [enterpriseInfoLogList, setEnterpriseInfoLogList] = useState([]);
  // 企
  function checkQwDetail() {
    getQwDetail();
    setQwModalVisible(true);
  }
  function getQwDetail() {
    getEnterprise({
      requestData: {
        tenantId: tenantInfo.tenantId,
      },
    }).then(({ code, data }) => {
      if (code === '00000') {
        setQwDetail(data || {});
        // 设置操作记录
        setEnterpriseInfoLogList(data?.enterpriseInfoLogList || []);
      } else {
        message.error(data?.msg || '获取企业信息失败');
      }
    });
  }

  // 打开编辑企业信息弹窗
  function openEditQwModal() {
    editQwForm.setFieldsValue({
      enterpriseName: qwDetail.enterpriseName,
      enterpriseLicenseCode: qwDetail.enterpriseLicenseCode,
    });
    // 设置营业执照图片
    if (qwDetail.enterpriseLicense) {
      setLicenseImageList([{ url: qwDetail.enterpriseLicense }]);
    } else {
      setLicenseImageList([]);
    }
    setEditQwModalVisible(true);
  }

  // 保存企业信息编辑
  function saveQwEdit() {
    editQwForm.validateFields().then((values) => {
      const licenseUrl =
        licenseImageList.length > 0 ? licenseImageList[0].url : '';
      modifyEnterpriseInfo({
        requestData: {
          tenantId: tenantInfo.tenantId,
          enterpriseName: values.enterpriseName,
          enterpriseLicenseCode: values.enterpriseLicenseCode,
          enterpriseLicense: licenseUrl,
        },
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('保存成功');
          setEditQwModalVisible(false);
          editQwForm.resetFields();
          setLicenseImageList([]);
          getQwDetail();
          onRefresh();
        } else {
          message.error(msg || '保存失败');
        }
      });
    });
  }

  // 取消编辑企业信息
  function cancelQwEdit() {
    editQwForm.resetFields();
    setLicenseImageList([]);
    setEditQwModalVisible(false);
  }

  function qwDetailView() {
    return (
      <Modal
        title="企业信息"
        visible={qwModalVisible}
        width={800}
        open={qwModalVisible}
        onCancel={() => {
          setQwModalVisible(false);
        }}
        footer={null}
      >
        <div>
          <div className={styles.statusRow}>
            <span className={styles.bold}>审核状态</span>
            <div>
              <span className={styles.mrM}>
                {qwDetail.enterpriseVerificationStatus == 2 ? (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    待审核
                  </a>
                ) : qwDetail.enterpriseVerificationStatus == 3 ? (
                  <span className={styles.statusOk}>审核通过</span>
                ) : qwDetail.enterpriseVerificationStatus == 4 ? (
                  <span className={styles.statusFail}>审核失败</span>
                ) : (
                  '--'
                )}
              </span>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setQwModalVisible(false);
                  openEditQwModal();
                }}
              >
                编辑
              </Button>
            </div>
          </div>
          <Descriptions column={2} size="small" bordered layout="vertical">
            <Descriptions.Item label="商家名称">
              {tenantInfo.name || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="主体类型">
              {qwDetail.enterpriseEntityType == 1
                ? '工商企业/其他'
                : '个体工商户'}
            </Descriptions.Item>
            <Descriptions.Item label="行业类别">
              {/* 企业分类: 1:健身行业 2:康复机构 3:MCN / 内容机构 4:保险行业 5:政府 / 公益单位 6:健康管理 / 医疗机构 7:其他 */}
              {qwDetail.enterpriseCategory == 1
                ? '健身行业'
                : qwDetail.enterpriseCategory == 2
                ? '康复机构'
                : qwDetail.enterpriseCategory == 3
                ? 'MCN / 内容机构'
                : qwDetail.enterpriseCategory == 4
                ? '保险行业'
                : qwDetail.enterpriseCategory == 5
                ? '政府 / 公益单位'
                : qwDetail.enterpriseCategory == 6
                ? '健康管理 / 医疗机构'
                : '其他'}
            </Descriptions.Item>
            <Descriptions.Item label="所在地">
              {qwDetail.address || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="企业名称">
              {qwDetail.enterpriseName || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="执照号/统一社会信用代码">
              {qwDetail.enterpriseLicenseCode || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="营业执照">
              {(() => {
                const license = qwDetail.enterpriseLicense || '';

                // 判断是否为图片URL
                const isImageUrl = (url) => {
                  if (!url || typeof url !== 'string') return false;
                  const imageExtensions =
                    /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i;
                  return imageExtensions.test(url);
                };

                // 判断是否为有效URL
                const isValidUrl = (string) => {
                  try {
                    const url = new URL(string);
                    return !!url;
                  } catch {
                    return false;
                  }
                };

                if (isImageUrl(license)) {
                  // 显示图片
                  return (
                    <Image
                      src={license}
                      alt="营业执照"
                      className={styles.licenseImg}
                      preview={{
                        mask: '点击预览',
                      }}
                    />
                  );
                }
                if (isValidUrl(license)) {
                  // 显示链接
                  return (
                    <a
                      href={license}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      {license}
                    </a>
                  );
                }
                // 显示文本
                return license;
              })()}
            </Descriptions.Item>
          </Descriptions>

          <Divider className={styles.dividerGap} />

          <div className={styles.mtM}>
            <div className={styles.blockTitle}>操作记录</div>
            <Table
              dataSource={enterpriseInfoLogList}
              pagination={false}
              size="small"
              rowKey={(record, index) => index}
              columns={[
                {
                  title: '记录',
                  dataIndex: 'operateTypeStr',
                  align: 'center',
                  render: (text) => text || '--',
                },
                {
                  title: '操作时间',
                  dataIndex: 'operatorTime',
                  align: 'center',
                },
                {
                  title: '操作人',
                  dataIndex: 'operator',
                  align: 'center',
                  render: (text) => text || '--',
                },
              ]}
            />
          </div>
        </div>
      </Modal>
    );
  }

  // 编辑企业信息弹窗
  function editQwModalView() {
    return (
      <Modal
        title="编辑企业信息"
        visible={editQwModalVisible}
        width={600}
        onCancel={cancelQwEdit}
        footer={null}
      >
        <Form form={editQwForm} {...layout}>
          <Form.Item
            label="企业名称"
            name="enterpriseName"
            rules={[
              { required: true, message: '请输入企业名称' },
              { max: 100, message: '企业名称不超过100个字符' },
            ]}
          >
            <Input placeholder="请输入企业名称" />
          </Form.Item>

          <Form.Item
            label="企业信用代码"
            name="enterpriseLicenseCode"
            rules={[
              { required: true, message: '请输入企业信用代码' },
              { max: 50, message: '企业信用代码不超过50个字符' },
            ]}
          >
            <Input placeholder="请输入企业信用代码" />
          </Form.Item>

          <Form.Item
            label="营业执照"
            name="license"
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (licenseImageList.length > 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('请上传营业执照'));
                },
              },
            ]}
          >
            <ImgUpload
              maxSize={10 * 1024 * 1024}
              imgList={licenseImageList}
              setImgList={(list) => {
                setLicenseImageList(list);
                // 图片列表变化时触发表单验证
                editQwForm.validateFields(['license']);
              }}
            />
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Space size={100}>
              <Button type="primary" onClick={saveQwEdit}>
                保存
              </Button>
              <Button onClick={cancelQwEdit}>取消</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  function deleteBind(record) {
    unBindChannel({
      requestData: {
        id: record.id,
      },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        onRefresh();
        actionRef?.current?.reload();
      } else {
        message.error(msg);
      }
    });
  }

  function formSubmit() {
    releaseForm.validateFields().then((values) => {
      bindTenant({
        requestData: {
          ...values,
          tenantId: tenantInfo?.tenantId,
        },
      }).then(({ code, msg }) => {
        if (code === '00000') {
          onRefresh();
          actionRef?.current?.reloadAndRest();
          // 清空表单
          releaseForm.resetFields();
          setBindOptionModalVisible(false);
        } else {
          message.error(msg);
        }
      });
    });
  }

  function formCancel() {
    // 清空表单
    releaseForm.resetFields();
    setBindOptionModalVisible(false);
  }

  const bindColumns = [
    {
      title: '创建时间',
      dataIndex: 'mtime',
      valueType: 'dateTime',
    },
    {
      title: '归属关系',
      dataIndex: 'bindTypeName',
    },
    {
      title: '名称',
      dataIndex: 'refId',
      hideInSearch: true,
      render: (_, record, index) => {
        const { refId, refName } = record;
        return (
          <Space>
            <Tag>{refId}</Tag>
            {refName}
          </Space>
        );
      },
    },

    {
      title: '归属状态',
      dataIndex: 'bindStatus',
      valueType: 'select',
      hideInSearch: true,
      valueEnum: {
        1: { text: '绑定' },
        2: { text: '解绑' },
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      hideInSearch: true,
      ellipsis: true,
      width: '200',
      render: (_, record, index) => {
        if (record.remark) {
          return (
            <Popover content={record.remark} showArrow={false}>
              <div className={styles.cellEllipsis}>{record.remark}</div>
            </Popover>
          );
        }
        return '-';
      },
    },
    {
      title: '操作',
      dataIndex: 'option',
      fixed: 'right',
      width: '80px',
      render: (_, record, index, action) => {
        return (
          <Space>
            {record.bindStatus === 1 ? (
              <Popconfirm
                title="确定要解绑吗?"
                key="pepform"
                onConfirm={() => deleteBind(record)}
                okText="确认"
                cancelText="取消"
              >
                <a type={'link'}>解绑</a>
              </Popconfirm>
            ) : (
              '-'
            )}
          </Space>
        );
      },
    },
  ];
  function bindDetailView() {
    return (
      <Modal
        title="归属关系"
        visible={bindModalVisible}
        width={800}
        open={bindModalVisible}
        onCancel={() => {
          setBindModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={bindColumns}
          actionRef={actionRef}
          request={async (params) => {
            const { data, page, code } = await getBindTenantList({
              requestData: { ...params, tenantId: tenantInfo?.tenantId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey="wxUserId"
          search={false}
          toolBarRender={false}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 请求
  async function fetchUserList(username, type) {
    if (type == 2) {
      return getBindBrandList({
        requestData: { brandName: username },
      }).then((body) =>
        body?.data?.map((item) => {
          // options 固定结构
          return {
            label: `【ID${item.id}】${item.brandName}`,
            value: item.id,
          };
        }),
      );
    } else {
      return getChannelListForBind({
        requestData: { channelName: username },
      }).then((body) =>
        body?.data?.map((item) => {
          // options 固定结构
          return {
            label: `【ID${item.id}】${item.channelName}`,
            value: item.id,
          };
        }),
      );
    }
  }

  // 分配modal
  function bindModal() {
    return (
      <div>
        <Modal
          title="商家归属"
          visible={bindOptionModalVisible}
          onCancel={() => {
            setBindOptionModalVisible(false);
          }}
          width={800}
          footer={null}
        >
          <Form
            className={styles.formGap}
            form={releaseForm}
            name="edit"
            {...layout}
          >
            <Form.Item
              name="type"
              label="类型"
              rules={[
                {
                  required: true,
                  message: '请选择类型',
                },
              ]}
              initialValue={1}
            >
              <Radio.Group
                onChange={() => {
                  releaseForm.setFieldValue('refId', undefined);
                  fetchUserList('', releaseForm.getFieldValue('type')).then(
                    (res) => {
                      setDefaultOptions(res || []);
                    },
                  );
                }}
              >
                <Radio value={1}>代理商</Radio>
                <Radio value={2}>品牌商</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="名称"
              name="refId"
              rules={[
                {
                  required: true,
                  message: '请选择',
                },
              ]}
            >
              <DebounceSelect
                labelInValue={false}
                className={styles.wFull}
                showSearch
                // value={merchantValue}
                defaultOptions={defaultOptions}
                placeholder="支持模糊搜索"
                fetchOptions={(username) =>
                  fetchUserList(username, releaseForm.getFieldValue('type'))
                }
                // onChange={(newValue) => {
                //   setMerchantValue(newValue);
                // }}
              />
            </Form.Item>
            <Form.Item label="备注信息" name="remark">
              <Input.TextArea
                placeholder="限制2千个字符以内"
                maxLength={2000}
                rows={3}
              />
            </Form.Item>

            <Form.Item {...tailLayout}>
              <Space size={100}>
                <Button type="primary" onClick={formSubmit}>
                  确定
                </Button>
                <Button onClick={formCancel}>取消</Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  return (
    <div>
      <Descriptions column={3}>
        <Descriptions.Item label="商家名称">
          {tenantInfo.name || '--'}
        </Descriptions.Item>
        <Descriptions.Item label="商家创建时间">
          {tenantInfo.ctime || '--'}
        </Descriptions.Item>
        {/*
          保证金余额 / 在途资金 / 可提现资金 / 累计提现 已按框架更新移出基础信息，
          改在「商家档案 → 资金与结算 → 资金概览」展示；
          先用后付记录入口随之迁到 DeductPlanModal。
          注意：这里必须是完整的 {/* *\/} 一对花括号——多出来的 } 会变成
          文本子节点，antd Descriptions 会把它当 Item 读 props.label 而整页崩溃。
        */}
        <Descriptions.Item label="小红书ID">
          {localXhsId || '--'}
          {tenantInfo.tenantThirdAccountModels &&
            tenantInfo.tenantThirdAccountModels.length > 0 && (
              <FileSearchOutlined
                className={styles.iconActionGap}
                onClick={showModal}
              />
            )}
        </Descriptions.Item>
        <Descriptions.Item label="视频号ID">
          {localVideoId || '--'}
          {tenantInfo.tenantThirdAccountModels &&
            tenantInfo.tenantThirdAccountModels.length > 0 && (
              <FileSearchOutlined
                className={styles.iconActionGap}
                onClick={showModal}
              />
            )}
        </Descriptions.Item>
        <Descriptions.Item label="企业信息" span={3}>
          {tenantInfo.enterpriseName ? (
            <a className={styles.link} onClick={checkQwDetail}>
              {tenantInfo.enterpriseName || '--'}
            </a>
          ) : (
            '--'
          )}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions column={3}>
        <Descriptions.Item label="店铺介绍" span={1}>
          {tenantInfo.intro || '--'}
        </Descriptions.Item>
        <Descriptions.Item label="归属关系" span={2}>
          <Space>
            {tenantInfo.tenantBind || '--'}
            <FileSearchOutlined
              className={styles.iconAction}
              onClick={() => {
                setBindModalVisible(true);
              }}
            />
            <a
              type="link"
              onClick={() => {
                fetchUserList('', 1).then((res) => {
                  setDefaultOptions(res || []);
                });
                setBindOptionModalVisible(true);
              }}
            >
              分配
            </a>
          </Space>
        </Descriptions.Item>

        <Descriptions.Item label="位置信息" span={3}>
          {tenantInfo.location &&
          tenantInfo.longitude &&
          tenantInfo.latitude ? (
            <a
              href={`https://uri.amap.com/marker?position=${tenantInfo.longitude},${tenantInfo.latitude}&name=${tenantInfo.location}&src=athena`}
              target="_blank"
              rel="noreferrer"
            >
              {tenantInfo.location}
              {tenantInfo.guide && <label>({tenantInfo.guide})</label>}
              <EnvironmentTwoTone className={styles.mlS} />
            </a>
          ) : (
            '--'
          )}
        </Descriptions.Item>
      </Descriptions>

      <Modal
        title="商家公域账号ID"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={1000}
        footer={null}
      >
        <Table
          dataSource={dataSource}
          pagination={false}
          size="small"
          scroll={{ x: 'max-content' }}
        >
          <Table.Column
            title="创建时间"
            dataIndex="createTime"
            key="createTime"
            width={200}
          />
          <Table.Column
            title="类型"
            dataIndex="storeTypeDesc"
            key="storeTypeDesc"
            width={80}
            render={(text, record) => {
              if (record.storeType === 5) return '小红书';
              if (record.storeType === 3) return '视频号';
              return text || '-';
            }}
          />
          <Table.Column
            title="账号ID"
            dataIndex="thirdAccountId"
            key="thirdAccountId"
            render={(text, record) => {
              const isEditing =
                editingField &&
                editingField.recordKey === record.key &&
                editingField.field === 'thirdAccountId';

              if (isEditing) {
                return (
                  <div className={styles.cellWithIcon}>
                    <Input
                      value={text}
                      maxLength={32}
                      onChange={(e) => {
                        const newData = dataSource.map((item) => {
                          if (item.key === record.key) {
                            return { ...item, thirdAccountId: e.target.value };
                          }
                          return item;
                        });
                        setDataSource(newData);
                      }}
                      className={styles.flex1}
                    />
                    <Button
                      type="primary"
                      size="small"
                      onClick={handleSave}
                      className={styles.mrXxs}
                    >
                      保存
                    </Button>
                    <Button size="small" onClick={handleCancel}>
                      取消
                    </Button>
                  </div>
                );
              }

              return (
                <div className={styles.cellWithIcon}>
                  <span>{text || '-'}</span>
                  <EditOutlined
                    className={styles.iconAction}
                    onClick={() => handleEdit(record, 'thirdAccountId')}
                  />
                </div>
              );
            }}
          />
          <Table.Column
            title="截图"
            dataIndex="thirdAccountImg"
            key="thirdAccountImg"
            width={80}
            render={(text, record) => {
              return text ? (
                <Image src={text} alt="商家图片" className={styles.thumbSm} />
              ) : (
                '-'
              );
            }}
          />
          <Table.Column
            title="最近修改时间"
            dataIndex="updateTime"
            key="updateTime"
            width={120}
          />
          <Table.Column
            title="买手口令"
            dataIndex="thirdBuyerId"
            key="thirdBuyerId"
            render={(text, record) => {
              const isEditing =
                editingField &&
                editingField.recordKey === record.key &&
                editingField.field === 'thirdBuyerId';

              if (isEditing) {
                return (
                  <div className={styles.cellWithIcon}>
                    <Input
                      value={text}
                      maxLength={32}
                      onChange={(e) => {
                        const newData = dataSource.map((item) => {
                          if (item.key === record.key) {
                            return { ...item, thirdBuyerId: e.target.value };
                          }
                          return item;
                        });
                        setDataSource(newData);
                      }}
                      className={styles.flex1}
                    />
                    <Button
                      type="primary"
                      size="small"
                      onClick={handleSave}
                      className={styles.mrXxs}
                    >
                      保存
                    </Button>
                    <Button size="small" onClick={handleCancel}>
                      取消
                    </Button>
                  </div>
                );
              }

              return (
                <div className={styles.cellWithIcon}>
                  <span>{text || '-'}</span>
                  {record.storeType === 5 && (
                    <EditOutlined
                      className={styles.iconAction}
                      onClick={() => handleEdit(record, 'thirdBuyerId')}
                    />
                  )}
                </div>
              );
            }}
          />
        </Table>
      </Modal>
      {qwDetailView()}
      {editQwModalView()}
      {renderStateModal()}
      {bindDetailView()}
      {bindModal()}
    </div>
  );
};

export default MerchantInfo;
